/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData';
import {
    instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataToJSON,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData';

/**
 * @type FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin
 * 
 * @export
 */
export type FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin = FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData;

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData(json)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSON(json: any): any {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLoginToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestVkIdLogin | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData(value)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthDataToJSON(value as FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersVkIdVkIdAuthData);
    }

    return {};
}

